export const states = [
  { title: 'WP Kuala Lumpur', value: 'WP Kuala Lumpur' },
  { title: 'WP Putrajaya', value: 'WP Putrajaya' },
  { title: 'Selangor', value: 'Selangor' },
  { title: 'Johor', value: 'Johor' },
  { title: 'Kedah', value: 'Kedah' },
  { title: 'Kelantan', value: 'Kelantan' },
  { title: 'Melaka', value: 'Melaka' },
  { title: 'Negeri Sembilan', value: 'Negeri Sembilan' },
  { title: 'Pahang', value: 'Pahang' },
  { title: 'Perak', value: 'Perak' },
  { title: 'Perlis', value: 'Perlis' },
  { title: 'Pulau Pinang', value: 'Pulau Pinang' },
  { title: 'Sabah', value: 'Sabah' },
  { title: 'Sarawak', value: 'Sarawak' },
  { title: 'Terengganu', value: 'Terengganu' },
  { title: 'Not applicable', value: 'Not applicable' },
];
